<template>
    <div class="push-notification-container flex flex-col items-center text-center p-4">
      <div class="notification-preview mb-4 p-6">
        <img v-if="isTodayTotal" :src="require('@/assets/faltando-deposito.png')" alt="Push Notification Preview" class="notification-image">
        <img v-else :src="require('@/assets/deposite-mais.png')" alt="Push Notification Preview" class="notification-image">
      </div>
      <div v-if="isTodayTotal">
        <div class="flex justify-center mb-4">
          <div class="custom-emoji-icon">
            <span class="text-2xl">⚠️ Atenção</span>
          </div>
        </div>
        <div class="notification-content">
          <p class="description">
              Faça um depósito e acesse gratuitamente o Modo Hack
          </p>
        </div>
      </div>
      <div v-else>
        <div class="flex justify-center mb-4">
          <div class="custom-emoji-icon">
            <span style="border: 1px solid #FF9213" class="text-2xl bg-[#FF921354] p-1 px-2 rounded-[7px]">R$ {{ todayTotal }}</span>
            <span class="text-2xl ml-2">depositados hoje</span>
          </div>
        </div>
        <div class="notification-content">
          <p class="description">
            <b>Deposite mais R$ {{ 50 - todayTotal }}</b> para liberar acesso a versão TRIAL do aplicativo.
          </p>
        </div>
      </div>
      <button @click="openDeposit" class="start-button mt-4 w-full">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00033 1.16669C6.64882 1.16669 5.32767 1.56746 4.20393 2.31831C3.0802 3.06917 2.20435 4.13639 1.68715 5.38502C1.16995 6.63364 1.03463 8.0076 1.2983 9.33314C1.56196 10.6587 2.21277 11.8763 3.16843 12.8319C4.12409 13.7876 5.34167 14.4384 6.66721 14.7021C7.99275 14.9657 9.3667 14.8304 10.6153 14.3132C11.864 13.796 12.9312 12.9202 13.682 11.7964C14.4329 10.6727 14.8337 9.35153 14.8337 8.00002C14.8319 6.18825 14.1114 4.45119 12.8303 3.17007C11.5492 1.88896 9.8121 1.16845 8.00033 1.16669ZM8.50033 11.8334V12.36C8.50033 12.4926 8.44765 12.6198 8.35388 12.7136C8.26011 12.8073 8.13294 12.86 8.00033 12.86C7.86772 12.86 7.74054 12.8073 7.64678 12.7136C7.55301 12.6198 7.50033 12.4926 7.50033 12.36V11.8334C7.06588 11.7684 6.6589 11.5811 6.32699 11.2934C6.09035 11.0945 5.89546 10.8507 5.75357 10.5761C5.61168 10.3014 5.52561 10.0014 5.50033 9.69335C5.49189 9.59485 5.51284 9.49606 5.56054 9.40947C5.60823 9.32287 5.68052 9.25236 5.76828 9.20684C5.85604 9.16132 5.95532 9.14283 6.05358 9.15372C6.15184 9.16461 6.24467 9.20439 6.32033 9.26802C6.42239 9.35296 6.48702 9.47457 6.50033 9.60669C6.51308 9.78499 6.56155 9.95891 6.64287 10.1181C6.72418 10.2773 6.83668 10.4185 6.97366 10.5334C7.24879 10.7695 7.60513 10.889 7.96699 10.8667C9.00699 10.8667 9.50033 10.4667 9.50033 9.65335C9.50033 9.11335 9.02699 8.53335 8.00033 8.53335C5.827 8.53335 5.50033 7.20002 5.50033 6.43335C5.5181 5.95525 5.6824 5.49417 5.97098 5.11258C6.25956 4.73098 6.65847 4.44732 7.11366 4.30002C7.24033 4.26069 7.36899 4.23202 7.50033 4.21335V3.69335C7.50033 3.56075 7.55301 3.43357 7.64678 3.3398C7.74054 3.24603 7.86772 3.19335 8.00033 3.19335C8.13294 3.19335 8.26011 3.24603 8.35388 3.3398C8.44765 3.43357 8.50033 3.56075 8.50033 3.69335V4.23335C9.02371 4.32064 9.50357 4.57845 9.86527 4.96668C10.227 5.3549 10.4502 5.85178 10.5003 6.38002C10.5058 6.50755 10.4623 6.63234 10.3787 6.72883C10.2952 6.82532 10.1779 6.88619 10.0509 6.89898C9.92387 6.91176 9.79679 6.87549 9.69566 6.79759C9.59454 6.7197 9.52704 6.60608 9.507 6.48002C9.46994 6.11822 9.2961 5.78423 9.02101 5.54631C8.74592 5.3084 8.39036 5.18453 8.02699 5.20002H7.90699C7.7446 5.19874 7.58289 5.2212 7.427 5.26669C7.25641 5.32232 7.09882 5.41182 6.96365 5.52981C6.82847 5.6478 6.71851 5.79186 6.64033 5.95335C6.55958 6.11292 6.51411 6.28799 6.507 6.46669C6.507 7.01335 6.687 7.54669 8.007 7.54669C9.647 7.54669 10.507 8.61335 10.507 9.66669C10.5159 9.94118 10.4701 10.2147 10.3724 10.4714C10.2747 10.728 10.127 10.9627 9.93779 11.1618C9.74862 11.3609 9.52177 11.5205 9.27043 11.6312C9.01909 11.7419 8.74825 11.8015 8.47366 11.8067L8.50033 11.8334Z" fill="white"/>
        </svg>
        <span class="ml-1">
            Realizar depósito
        </span>
      </button>
      <button @click="disableNotifications" class="cancel-button mt-2 w-full">
        Não, obrigado
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MissingDeposit',
    props: ['iframeSrc', 'todayTotal'],
    data() {
      return {
        pushImage: require('@/assets/faltando-deposito.png'),
        isTodayTotal: this.todayTotal == 0,
      };
    },
    methods: {
      disableNotifications() {
        console.log('Notificações desativadas');
        this.$emit('notifications-disabled'); // Emit event to parent component
      },
      openDeposit() {
        // pwa open url on browser
        window.open(this.iframeSrc, '_blank');
      },
    }
  };
  </script>
  
  <style scoped>
  .custom-emoji-icon {
    font-size: 20px;
    color: white;

  }
  
  .push-notification-container {
    border-radius: 20px;
    padding: 20px;
    max-width: 400px;
    margin: auto;
  }
  
  .notification-preview {
    width: 100%;
  }
  
  .notification-image {
    width: 100%;
    border-radius: 20px;
    object-fit: cover;
  }
  
  .notification-label {
    font-size: 12px;
    color: white;
    margin-bottom: 8px;
  }
  
  .title {
    font-size: 24px;
    font-weight: bold;
    color: white;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: white;
    margin-bottom: 20px;
    line-height: 1.5;
  }
  
  .start-button {
    background-color: #2555FF;
    color: white;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .start-button:hover {
    background-color: #1e4ec1;
  }
  
  .cancel-button {
    background: none;
    border: none;
    color: #797180;
    cursor: pointer;
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
  }
  </style>
  